module.exports = __webpack_public_path__ + "static/media/disclaimer.394b853d.png";